import { Box, Card, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { convertDateTimeToTz } from "../../../utils/helper/timeHelpers";
import { LABEL_TYPE, TIMEZONE } from "../../../utils/Constant";
import Label from '../../../comman/Label'
import { formatFileURL } from "../../../utils/helper/appHelpers";
import logo from "../../../assets/profile.png";
import { apiRequest } from "../../../utils/config/apiRequest";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import { useParams } from "react-router-dom";

const CustomerDetails = () => {
    const { customerId } = useParams()

    const [state, setState] = useState({ orderStats: [] })

      const fetchDetails = async () => {
        let { data, status } = await apiRequest({
            endUrl: apiUrl.users.listing,
            params: { _id: customerId }
        })
        if (status) {
            setState({ ...state, ...data })
        }
    }

        useEffect(() => {
        fetchDetails();
    }, [])

  
  return (
       <section className="content mb-5">
         <div className="container-fluid" >
           <div className="row titlepad publsih-sticky">
             <div className="col-md-12">
               <div className="mt-3 mb-3">
                 <div className="dashbed-border-bottom"></div>
               </div>
               <div className="row">
                 <div className="col-sm-7">
                   <h4>Customer Details</h4>
                 </div>

                  <Grid container spacing={2} mt={1}>

                <Grid item md={8} xs={12}>

                    {/* Basic details */}
                    <Card sx={{ p: 2, mb: 2, height: '100%' }}>
                        <Typography variant='h6'>Basic Details</Typography>
                        <Divider />
                        <Grid container>
                            <Grid item md={4} xs={6}>
                                <Typography variant='caption'>User Name</Typography>
                                <Typography variant='subtitle2'>{state?.userName}</Typography>
                            </Grid>
                            <Grid item md={4} xs={6}>
                                <Typography variant='caption'>Email</Typography>
                                <Typography variant='subtitle2'>{state?.email}</Typography>
                            </Grid>
                            <Grid item md={4} xs={6}>
                                <Typography variant='caption'>Mobile</Typography>
                                <Typography variant='subtitle2'>{state?.dialCode} {state?.mobileNo}</Typography>
                            </Grid>

                            <Grid item md={4} xs={6}>
                                <Typography variant='caption'>Registered On</Typography>
                                <Typography variant='subtitle2'>{convertDateTimeToTz(state?.createdAt, TIMEZONE['America/Toronto'], 'DD MMM, YYYY')}</Typography>
                            </Grid>
                        </Grid>
                    </Card>

                </Grid>

                {/* Right side profile card */}
                <Grid item md={4} xs={12}>
                    <Card sx={{ p: 2, position: 'relative', zIndex: 1, overflow: 'unset' }}>
                        <Grid container>
                            <Grid item md={6}>
                                <Box
                                    sx={{
                                        height: 90,
                                        width: 90,
                                        borderRadius: 10,
                                        border: '#fff 3px solid',
                                        boxShadow: '0 0 7px 5px rgb(0 0 0 / 10%)'
                                    }}
                                    component={'img'}
                                    src={state?.profilePic ? formatFileURL(state?.profilePic) : logo}
                                />
                            </Grid>
                            <Grid item md={6} display={'flex'} justifyContent={'flex-end'}>
                                <Label type={LABEL_TYPE?.STATUS} value={state?.status}>{state?.status}</Label>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>

                
               </div>
             </div>
           </div>
          
         </div>
         {/* Add service */}

       </section>
  );
};

export default CustomerDetails;
